/**
 * Tur 23 plan uyum (D072, Yapim-B): sepet bandi oturum boyu HER sayfada. Urun sayfasinda bandi assets/ag-urun-ek.js kurar
 * (sepete ekleme ani S024 + vapur S078); bu dosya diger sayfalarda ayni bandi, bu oturumda bir kez kurulduysa ve sepette parca
 * varsa gosterir, sepet degisince sayiyi tazeler, sepet bosalinca kaldirir. Anahtar S024 (birlesik). Gorunum assets/ag-bant.css.
 * Yukleme: layout/theme.liquid (ortak dosya - TESLIM-B).
 */
(function () {
  'use strict';
  if (document.getElementById('ag-product-data')) return; /* urun sayfasi: ag-urun-ek.js */
  if (!(window.agOz && window.agOz('S024'))) return;
  if (document.body && document.body.getAttribute('data-ag-template') === 'cart') return; /* Son tur E5: sepet sayfasinda bant yok (zaten sepettesin) */
  var D = document.documentElement;
  var src = (document.currentScript && document.currentScript.src) || '';
  var korfez = src ? src.replace(/ag-b-sepetbant\.js[^/]*$/, 'ag-bant-korfez-gece.webp') : '';
  var oturum = false; try { oturum = sessionStorage.getItem('ag:sepetbant') === '1'; } catch (e) {}
  if (!oturum) return;
  function kur(adet) {
    var b = document.querySelector('.ag-sepetbant');
    if (!b) {
      b = document.createElement('div'); b.className = 'ag-sepetbant'; b.setAttribute('role', 'region'); b.setAttribute('aria-label', 'Sepet');
      b.innerHTML = '<button type="button" class="ag-sepetbant__sepet" data-ag-sepetbant-ac><img alt="" width="32" height="32"><span class="ag-sepetbant__metin"></span></button>' +
        '<a class="ag-sepetbant__odeme" href="/checkout">Ödemeye geç <span aria-hidden="true">→</span></a>';
      if (korfez) b.style.setProperty('--ag-korfez', 'url("' + korfez + '")');
      document.body.appendChild(b);
      b.querySelector('[data-ag-sepetbant-ac]').addEventListener('click', function () { if (window.AGCart && window.AGCart.open) window.AGCart.open(); });
      D.classList.add('ag-sepetbant-var');
    }
    b.querySelector('.ag-sepetbant__metin').textContent = 'SEPETİNDE ' + adet + ' PARÇA';
    b.querySelector('.ag-sepetbant__sepet').setAttribute('aria-label', 'Sepetinde ' + adet + ' parça, sepeti aç');
    return b;
  }
  function resim(b, items) {
    var i = b && b.querySelector('img'); if (!i) return;
    var u = items && items[0] && (items[0].featured_image && items[0].featured_image.url || items[0].image);
    if (u) i.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96'; else i.remove();
  }
  function kaldir() { var b = document.querySelector('.ag-sepetbant'); if (b) b.remove(); D.classList.remove('ag-sepetbant-var'); }
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
    if (!c || !c.item_count) return;
    resim(kur(c.item_count), c.items);
  }).catch(function () {});
  document.addEventListener('ag:cart:updated', function (e) {
    var adet = e.detail && e.detail.count; if (adet == null) return;
    if (!adet) { kaldir(); return; }
    var var0 = !!document.querySelector('.ag-sepetbant'), b = kur(adet);
    if (!var0) fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { resim(b, c.items); }).catch(function () {});
  });
})();
